var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1514 12.0169C26.9894 12.0169 27.6598 11.3465 27.6598 10.5085C27.6598 9.67044 26.9894 9 26.1514 9C25.3134 9 24.6429 9.67044 24.6429 10.5085C24.6429 11.3465 25.3134 12.0169 26.1514 12.0169Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1514 40.8451C32.8556 40.8451 38.3028 34.0571 38.3028 25.593C38.3028 17.1289 32.8556 10.3409 26.1514 10.3409C19.4472 10.3409 14 17.1289 14 25.593C14 34.0571 19.4472 40.8451 26.1514 40.8451Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1514 42.4373C26.9894 42.4373 27.6598 41.7669 27.6598 40.9289C27.6598 40.0909 26.9894 39.4204 26.1514 39.4204C25.3134 39.4204 24.6429 40.0909 24.6429 40.9289C24.6429 41.7669 25.3134 42.4373 26.1514 42.4373Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.4c4f4a97ad509d05189762cb54987efa.svg";
export { ForwardRef as ReactComponent };